<template>
  <div class="page">
    <!-- 顶栏品牌 -->
    <header class="header">
      <div class="header__brand">
        <img
          class="header__logo"
          src="@/assets/images/logo.svg"
          alt="REHON"
        >
        <p class="header__name">河北瑞和生物科技集团</p>
      </div>
    </header>

    <!-- 厂区主图 -->
    <section class="banner">
      <div class="banner__frame">
        <img
          class="banner__img"
          src="@/assets/images/banner.png"
          alt="河北瑞和生物科技集团厂区"
        >
      </div>
    </section>

    <!-- 关于瑞和 -->
    <section class="about">
      <h1 class="about__title">关于瑞和</h1>
      <div class="about__content">
        <p class="about__text">
          瑞和河北生物科技集团有限公司，坐落于河北省邢台市，主营宠物冻干食品及功能性营养食品。现研发单品300余个。团队核心专家从业三十余年，继通过了FSSC、BRCGS、HACCP、美国FDA注册、出口三大洲共计20余个国家。
        </p>
        <p class="about__text">
          瑞和始终以“构建人宠共生的美好世界”为愿景，坚持“瑞选天然，和乐相伴”为核心价值锚点，让每一克产品都经得起专业验证，让养宠人对爱宠的“每一餐”都能安心、放心。这份价值观，既是我们深耕行业的初心，更是驱动技术创新、品质升级的精神内核。
        </p>
      </div>
    </section>

    <!-- 能力条目 + 食材图 -->
    <section class="features">
      <div class="features__list">
        <div
          v-for="item in featureList"
          :key="item.title[0]"
          class="features__item"
        >
          <span class="features__mark" aria-hidden="true"></span>
          <h2 class="features__title">
            <span>{{ item.title[0] }}</span>
            <span>{{ item.title[1] }}</span>
          </h2>
          <p class="features__desc">{{ item.desc }}</p>
        </div>
      </div>
      <div class="features__visual">
        <img
          class="features__img"
          src="@/assets/images/food.png"
          alt="瑞和食材原料"
        >
      </div>
    </section>

    <!-- 页脚备案 -->
    <footer class="footer">
      <p class="footer__copy">
        <span>版权所有：河北瑞和生物科技集团有限公司</span>
        <span class="footer__icp">备案号：冀ICP备2026033336号-1</span>
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'HomePage',
  data() {
    return {
      featureList: [
        {
          title: ['数字', '生产'],
          desc: '作为中国农科院数字农业农村研究院数字加工数字追溯产业园区，数字化产品工艺生产数据模型，实现产品研发精准实现，严控生产质量及营养成分。实现精准研发、高质落地、创意重塑及多元迭代。'
        },
        {
          title: ['全链', '溯源'],
          desc: '自研全自动溯源防伪系统，实现原料、运输、生产、质检、包装全链条数据留存可查、可追溯。以GS1标准实现一物一码，以数字化精益生产，兼顾规模化量产与精细化品控，全方位保障食品安全合规。'
        },
        {
          title: ['履约', '服务'],
          desc: '兼具国内流通与跨境出口包装交付能力，高效响应批量、定制及跨境订单。全程跟进履约交付与售后反馈，依托溯源体系快速响应客户核验咨询，提供一站式长效贴心服务保障。'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@use "sass:math";

$design-w: 1600;
$page-w: 1280;

@function px($n) {
  @return math.div($n * $page-w, $design-w) * 1px;
}

.page {
  position: relative;
  width: px(1600);
  height: px(1476);
  margin: 0 auto;
  overflow: hidden;
  background: #fff;
}

/* 顶栏品牌 */
.header {
  position: absolute;
  top: px(36);
  left: px(578);
  width: px(444);
  height: px(30);

  &__brand {
    display: flex;
    align-items: center;
    height: 100%;
  }

  &__logo {
    display: block;
    width: px(130);
    height: px(30);
    flex-shrink: 0;
  }

  &__name {
    margin-left: px(16);
    font-size: px(26.17);
    font-weight: 700;
    line-height: px(30);
    letter-spacing: px(3.851456);
    color: #0070fd;
    white-space: nowrap;
    transform: translateY(px(2));
  }
}

/* 厂区主图 */
.banner {
  position: absolute;
  top: px(101);
  left: px(172);
  width: px(1256);
  height: px(363);

  &__frame {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  &__img {
    display: block;
    width: px(1256);
    height: px(707);
    margin-top: px(-171);
    object-fit: cover;
    object-position: center;
  }
}

/* 关于瑞和 */
.about {
  position: absolute;
  top: px(514);
  left: px(308);
  width: px(984);

  &__title {
    font-size: px(24.18);
    font-weight: 700;
    line-height: px(27.78);
    letter-spacing: px(0.514464);
    color: #006afc;
    text-align: center;
  }

  &__content {
    margin-top: px(14);
  }

  &__text {
    font-size: px(15);
    font-weight: 400;
    line-height: px(30);
    letter-spacing: px(0.254323);
    color: #707070;
    text-align: left;
    text-indent: 2em;

    & + & {
      margin-top: px(12);
    }
  }
}

/* 能力条目 + 食材图 */
.features {
  &__list {
    position: absolute;
    top: px(833);
    left: px(224);
    width: px(658);
    height: px(408);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__item {
    position: relative;
    display: flex;
    align-items: flex-start;
    height: px(122);
  }

  &__mark {
    position: absolute;
    top: px(17);
    left: px(31);
    width: px(21);
    height: px(21);
    background: rgba(0, 106, 252, 0.2);
    pointer-events: none;
  }

  &__title {
    position: relative;
    z-index: 1;
    width: px(52);
    margin-top: px(14);
    flex-shrink: 0;
    font-size: px(24.18);
    font-weight: 700;
    line-height: px(27.78);
    letter-spacing: px(0.514464);
    color: #006afc;

    span {
      display: block;
    }
  }

  &__desc {
    width: px(589);
    margin-left: px(14);
    font-size: px(15);
    font-weight: 400;
    line-height: px(30);
    letter-spacing: px(0.254323);
    color: #707070;
  }

  &__visual {
    position: absolute;
    top: px(742);
    left: px(946);
    width: px(482);
    height: px(546);
  }

  &__img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
  }
}

/* 页脚备案 */
.footer {
  position: absolute;
  left: 0;
  right: 0;
  top: px(1385);
  text-align: center;

  &__copy {
    font-size: px(15);
    font-weight: 400;
    line-height: px(15);
    letter-spacing: px(0.254323);
    color: #707070;
  }

  &__icp {
    margin-left: px(45);
  }
}
</style>
